import React from 'react';
import { UploadCloud, Image, Video, Music, FileText } from 'lucide-react';
import { cn } from 'src/lib/utils';

type Props = {
  text?: string;
  children?: React.ReactNode;
  isActive?: boolean;
  showFileTypes?: boolean;
};

const DropzonePlaceholder: React.FC<Props> = ({
  text,
  children,
  isActive = false,
  showFileTypes = true,
}) => {
  return (
    <div
      className={cn(
        'tw-absolute tw-flex tw-h-full tw-w-full tw-select-none tw-items-center tw-justify-between tw-px-6 tw-py-3 tw-transition-all tw-duration-200',
        isActive && 'tw-bg-brand-50 tw-scale-105',
      )}
    >
      {/* Left: Upload cloud icon */}
      <div
        className={cn(
          'tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-brand-100 tw-transition-all tw-duration-200',
          isActive && 'tw-scale-110 tw-bg-brand-200',
        )}
      >
        <UploadCloud
          className={cn(
            'tw-h-6 tw-w-6 tw-text-brand-600 tw-transition-colors tw-duration-200',
            isActive && 'tw-text-brand-700',
          )}
        />
      </div>

      {/* Center: Text */}
      <p className="tw-text-xs tw-text-gray-600 sm:tw-text-sm">
        {text || (
          <>
            Drag and drop files here, or{' '}
            <span className="tw-font-medium tw-text-brand-600 tw-underline tw-decoration-dashed tw-underline-offset-2">
              click to browse
            </span>
          </>
        )}
      </p>

      {/* Right: File type icons */}
      {showFileTypes && (
        <div className="tw-flex tw-items-center tw-gap-3">
          <Image className="tw-h-5 tw-w-5 tw-text-blue-500" />
          <Video className="tw-h-5 tw-w-5 tw-text-purple-500" />
          <Music className="tw-h-5 tw-w-5 tw-text-green-500" />
          <FileText className="tw-h-5 tw-w-5 tw-text-red-500" />
        </div>
      )}

      {children}
    </div>
  );
};

export { DropzonePlaceholder };
